export const APP_VERSION = '1.21.5'
